import { Base } from './base.model';
import { Channel } from "./channel.model";
import { Company } from "./company.model";
import { IntegrationTypeEnum } from './enum/integration.enum.types';

export interface Integration extends Base {
  name: string;
  type: IntegrationTypeEnum;
  metadata: MetadataIntegration;
  actived: boolean;
  company: Company;
  user: Company;
  removed: boolean;
}

export type MetadataIntegration = OpenAIIntegration | GeminiIntegration | PipedriveIntegration | AgendorIntegration | GPTMakerIntegration;

export interface PipedriveIntegration {
  api_token: string
}

export interface AgendorIntegration {
  token: string;
}

export interface GPTMakerIntegration {
  apiToken: string;
  agents: Array<GPTMakerAgent>;
}

export interface GPTMakerAgent {
  id: string;
  name: string;
  createdAt: Date;
  channels: Array<Channel>;
}

export interface OpenAIIntegration {
  token: string;
  organization: string;
  project: string;
  assistants: Array<OpenAIAssistant>;
  /** Circuit-breaker state set by the backend when OpenAI rejects the integration; absent when healthy. */
  health?: IntegrationHealth;
}

/**
 * OpenAI agent configured in Trendmulti (mirror of trendmulti-entity `OpenAIAssistant`).
 * `model` + `instructions` are required for the agent to answer; legacy entries created
 * on the retired Assistants API (`asst_…` ids) have neither and must be reconfigured.
 */
export interface OpenAIAssistant {
  id: string;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
  channels: Array<Channel>;
  model?: string;
  description?: string;
  instructions?: string;
}

export enum IntegrationHealthStatusEnum {
  QUOTA_EXHAUSTED = 'QUOTA_EXHAUSTED',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  MODEL_NOT_FOUND = 'MODEL_NOT_FOUND',
}

export interface IntegrationHealth {
  status: IntegrationHealthStatusEnum;
  since: Date;
  lastError?: string;
  errorCode?: string;
  assistantId?: string;
}

/** Payload of POST/PUT /integration/assistant/:integrationId[/:assistantId]. */
export interface OpenAIAssistantInput {
  name: string;
  model: string;
  instructions: string;
  description?: string;
  channels: Array<{ _id: string; name?: string; type?: string }>;
}

/** True when the agent still has to be configured for the Responses API. */
export function openAIAssistantNeedsSetup(assistant: Partial<OpenAIAssistant> | null | undefined): boolean {
  return !assistant?.model || !assistant?.instructions?.trim();
}

export interface GeminiIntegration {
}
